import { Box, Drawer, IconButton, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { IoClose } from 'react-icons/io5';

export default function AlternativeNameFormSkeleton() {
  return (
    <Drawer
      anchor='right'
      open
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400, md: 720 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Header */}
      <Box
        px={3}
        py={2}
        borderBottom='1px solid #DEDEDE'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <Skeleton variant='text' width={200} height={28} />
        <IconButton size='small' disabled>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Body */}
      <Box sx={{ flex: 1, overflowY: 'auto', p: 3 }}>
        <Grid container spacing={2}>
          {/* Select Menu */}
          <Grid size={6}>
            <Skeleton variant='rectangular' height={56} />
          </Grid>

          {/* Select Item */}
          <Grid size={6}>
            <Skeleton variant='rectangular' height={56} />
          </Grid>

          {/* Item Alternative Names */}
          <Grid size={12}>
            <Skeleton variant='rectangular' height={56} />
            <Box mt={1}>
              <Skeleton variant='text' width='60%' />
            </Box>
          </Grid>
        </Grid>

        {/* Modifier Section */}
        <Box border='1px solid #ECECEC' p={2} my={3} borderRadius='4px'>
          <Skeleton variant='text' width={200} height={24} sx={{ mb: 2 }} />

          {[1, 2].map((_, index) => (
            <Grid container spacing={2} alignItems='center' key={index} mb={1}>
              <Grid size={5}>
                <Skeleton variant='rectangular' height={56} />
              </Grid>

              <Grid size={5}>
                <Skeleton variant='rectangular' height={56} />
              </Grid>

              <Grid size={2}>
                <Skeleton variant='circular' width={32} height={32} />
              </Grid>
            </Grid>
          ))}

          <Box display='flex' justifyContent='center' mt={2}>
            <Skeleton variant='rectangular' width={140} height={36} />
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Box px={3} py={2} borderTop='1px solid #DEDEDE' display='flex' justifyContent='flex-end' gap={2}>
        <Skeleton variant='rectangular' width={100} height={36} />
        <Skeleton variant='rectangular' width={120} height={36} />
      </Box>
    </Drawer>
  );
}
